import { CheckOutlined } from "@ant-design/icons";
import { Button, Tag, Tooltip } from "antd";
import { useKycAdd } from "hook/base/kyc/useKyc";
import React, { memo } from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const TableStatus = memo(({ record }) => {
  // -------------------------- VAR -----------------------------
  const { handleOpenPreview } = useKycAdd();
  const status = record?.status || "waiting";
  const isWaiting = status === "waiting";
  const isApprove = status === "verified";
  const isDeny = status === "deny";
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderWaiting = () => {
    if (!isWaiting) return null;
    return (
      <Tooltip title="Kiểm tra hình ảnh này">
        <Button
          onClick={() => handleOpenPreview(record)}
          size="middle"
          icon={<CheckOutlined />}
        />
      </Tooltip>
    );
  };

  const renderApproval = () => {
    if (!isApprove) return null;
    return <Tag color="green">Đã duyệt</Tag>;
  };

  const renderDeny = () => {
    if (!isDeny) return null;
    return <Tag color="red">Đã Từ chối</Tag>;
  };
  // -------------------------- MAIN ----------------------------
  return (
    <>
      {renderWaiting()}
      {renderApproval()}
      {renderDeny()}
    </>
  );
});
export default TableStatus;
